import '../orders.css';
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite';

const InputBtn = observer(({ value, choose, apply, placeholder }) => {

    const [state, setState] = useState(null)

    useEffect(() => {
        choose(state)
    // eslint-disable-next-line
    }, [state])

    return (

        <div className='order-element-search'>
            <input value={ value } onChange={e => setState(e.target.value)} placeholder={placeholder}/>
            <div onClick={ apply }></div>
        </div>
        
    )
})

export default InputBtn;